import { FOOTER_DISCLAIMER } from "@/lib/disclaimers";
import { Link } from "react-router-dom";

const LEGAL_LINKS = [
  { to: "/legal/terms", label: "이용약관" },
  { to: "/legal/privacy", label: "개인정보 처리방침" },
  { to: "/legal/risk", label: "투자 위험 고지" },
];

/** COPY.md 상시 고지 — rendered on every page, public and private alike. */
export function Footer() {
  return (
    /*
      상시 고지는 반드시 있어야 하지만 읽히는 순서는 마지막이에요. 예전에는 회색 슬래브 +
      큰 브랜드 + 구분선이라, 내용이 짧은 화면(/market, 규칙 1개짜리 /rules)에서 뷰포트의
      3분의 1을 먹고 본문과 경쟁했어요. 바탕을 본문과 같게 두고 hairline 하나로 끊습니다.
    */
    <footer className="mt-16 border-t border-line-alternative">
      <div className="mx-auto flex max-w-layout flex-col gap-3 px-5 py-7">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
          {/* 푸터는 읽히는 순서가 마지막이라 심볼 없이 워드마크만 둡니다 — 마크를 여기
              한 번 더 쓰면 헤더의 락업과 무게가 같아져요. */}
          <span className="text-label-1 text-label-neutral">tranche</span>
          <span className="text-caption-1 text-label-assistive">자문이 아니라 실행</span>
          <nav className="flex flex-wrap gap-4 sm:ml-auto">
            {LEGAL_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="inline-flex min-h-6 items-center text-caption-1 text-label-alternative transition-colors duration-fast ease-standard hover:text-label-normal"
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
        <p className="max-w-3xl whitespace-pre-line text-caption-1 text-label-assistive">
          {FOOTER_DISCLAIMER}
        </p>
      </div>
    </footer>
  );
}
